import { editHelpCenterExperienceId } from '@atlassian/help-center-common-util/analytics/ufo';
import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

export const editHelpCenterExperience = new UFOExperience(editHelpCenterExperienceId, {
	type: ExperienceTypes.Load,
	performanceType: ExperiencePerformanceTypes.PageLoad,
});
